import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=3123664d&scoped=true&"
import script from "./BalanceView.vue?vue&type=script&lang=ts&"
export * from "./BalanceView.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceView.vue?vue&type=style&index=0&id=3123664d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123664d",
  null
  
)

export default component.exports